const websiteForm = {
    feedbackList:()=>'admin/feedback-form',
    feedbackDetail:(id:string)=>`admin/feedback-form/${id}`,
    retailerList:()=>'admin/retailer-form',
    retailerDetail:(id:string)=>`admin/retailer-form/${id}`,
}

export default websiteForm